export default function DocumentManagementDirective() {
  return {
    restrict: 'E',
    template: require('./document-management.html'),
    scope: {
      serviceId: '@',
      dialogTitle: '@',
      toolTip: '@',
      tooltipAppendToSelector: '@',
      buttonStyle: '@',
      buttonText: '@',
      // refreshCallBack: '=',
      canAddFolder: '@',
      canDeleteFolder: '@',
      canAddDocument: '@',
      canDeleteDocument: '@',
      attachedIds: '=',
      maxAttachments: '@',
      attachCallback: '=',
      attachmentTypeId: '=',
      attachmentEntityId: '=',
      onOpenCallBack: '=',
      onCloseCallBack: '=',
      folderList: '=',
      customerServices: '=',
    },
    controller: 'DocumentManagementController',
    controllerAs: 'documentManagementVM',
    bindToController: true,
    replace: true,
  };
}
